module.exports = __webpack_public_path__ + "img/il.6b380c76.svg";